var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"pl-3"},[_vm._l((_vm.attachments),function(attachment){return [_c('li',{key:attachment.id ? attachment.id : attachment.url},[_c('i',{staticClass:"fas fa-file-alt pr-2"}),_c('a',{attrs:{"href":attachment.url,"download":attachment.name,"target":"_blank"}},[_vm._v(_vm._s(attachment.name))])])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }